export const parseYouTubeId = (url) => {
  const raw = String(url || '').trim();
  if (!raw) return null;
  try {
    const parsed = new URL(raw.includes('://') ? raw : `https://${raw}`);
    const host = parsed.hostname.toLowerCase();
    if (host === 'youtu.be' || host === 'www.youtu.be') {
      const id = parsed.pathname.replace(/^\//, '').split('/')[0];
      return id || null;
    }
    if (!host.includes('youtube.com')) return null;
    if (parsed.pathname === '/watch') {
      return parsed.searchParams.get('v');
    }
    const embedMatch = parsed.pathname.match(/^\/(?:embed|shorts|live)\/([^/?#]+)/);
    if (embedMatch) return embedMatch[1];
  } catch {
    const loose = raw.match(/(?:youtu\.be\/|v=|\/embed\/|\/shorts\/)([A-Za-z0-9_-]{6,})/);
    return loose ? loose[1] : null;
  }
  return null;
};

export const isYouTubeUrl = (url) => !!parseYouTubeId(url);

export const normalizeYouTubeUrl = (url) => {
  const id = parseYouTubeId(url);
  return id ? `https://www.youtube.com/watch?v=${id}` : '';
};

export const getYouTubeThumbnail = (url, quality = 'hqdefault') => {
  const id = parseYouTubeId(url);
  if (!id) return '';
  return `https://img.youtube.com/vi/${id}/${quality}.jpg`;
};

export const getYouTubeWatchUrl = (url) => normalizeYouTubeUrl(url);
